





















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({

})
export default class ErrorDialog extends Vue {
  @Prop() error!: { message: string; title?: string; color?: string } | null
  @Prop() close!: () => void

  get title () {
    if (this.error !== null) {
      return this.error.title || 'An Error Occured'
    }
    return '...'
  }

  get message () {
    if (this.error !== null) {
      return this.error.message || 'Unknown error'
    }
    return '...'
  }

  get color () {
    if (this.error !== null) {
      return this.error.color || 'error'
    }
    return '...'
  }
}
